// extracted by mini-css-extract-plugin
module.exports = {"background":"Videos_background__19NVr","container":"Videos_container__3LhTB"};